import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.DescripcionPaqueteDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre }) },
    { title: "Visible solo para clientes relacionados", cell: x => ({ data: x.VisibleClientesRelacionados }) },
    { title: "Peso Kg default", cell: x => ({ data: x.Peso }) },
    { title: "Largo cm default", cell: x => ({ data: x.Largo }) },
    { title: "Alto cm default", cell: x => ({ data: x.Alto }) },
    { title: "Ancho cm default", cell: x => ({ data: x.Ancho }) },
    { title: "Tipo embalaje Sat ", cell: x => ({ data: x.TipoEmbalaje.Clave+" - "+ x.TipoEmbalaje.Descripcion }) },
];

/**Obtiene las columnas del grid */
export function columnas(deps: kea.BotonesListaDeps<Entity>): Column[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [botones, ...columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/descripcionespaquete/list/columns.tsx